// src/utils/config.js

// export const BASE_URL = process.env.REACT_APP_BASE_URL;
/**
 * Determines the backend API URL dynamically based on the current hostname.
 * This allows the same frontend build to work across development, staging, and production.
 * @returns {string} The base URL for the backend API.
 */
const getBaseUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // For local development, use the URL from the .env file.
    return process.env.REACT_APP_BASE_URL || 'http://localhost:4000';
  }

  // For any deployed environment (e.g., invest.loginn.biz or seegsoog.com),
  // construct the URL dynamically. This assumes the backend is always served
  // from the '/invest_BE' path on the same domain as the frontend.
  return `${window.location.origin}/invest_BE`;
};

export const BASE_URL = getBaseUrl();
export const MAP_URL = 'https://nominatim.openstreetmap.org';
export const STATIC_ASSET_PATH_PREFIX = process.env.REACT_APP_STATIC_ASSET_PATH_PREFIX || '';

// Centralized flag to detect if the app is being run by react-snap for pre-rendering.
// Previous attempt (failed): export const IS_PRERENDERING = typeof navigator !== 'undefined' && /HeadlessChrome/.test(navigator.userAgent);
// The correct method for this environment, as seen in apiClient.js, is to check for "ReactSnap".
export const IS_PRERENDERING = typeof navigator !== 'undefined' && navigator.userAgent.includes('ReactSnap');

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Helper function to construct full image URLs robustly
export const getFullImageUrl = (imagePath) => {
  if (!imagePath) return '';

  let baseUrl = BASE_URL;
  let cleanedImagePath = imagePath;

  // Remove trailing slash from baseUrl if it exists
  if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }

  // Ensure imagePath starts with a single slash
  if (!cleanedImagePath.startsWith('/')) {
    cleanedImagePath = `/${cleanedImagePath}`;
  }

  const finalUrl = `${baseUrl}${cleanedImagePath}`;

  return finalUrl;
};
